import { render, staticRenderFns } from "./indexQh.vue?vue&type=template&id=cfb637fa&scoped=true"
import script from "./indexQh.vue?vue&type=script&lang=js"
export * from "./indexQh.vue?vue&type=script&lang=js"
import style0 from "./indexQh.vue?vue&type=style&index=0&id=cfb637fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfb637fa",
  null
  
)

export default component.exports